import { cn, FormatUtils, PaletteUtils } from '@shared/utils';
import type { RecipientResponse } from '@shared/api';
import { Text } from '@shared/widgets';

interface RecentRecipientProps {
  className?: string;
  recipient: RecipientResponse;
  onClick?: () => void;
}

export const RecentRecipient = (props: RecentRecipientProps) => {
  return (
    <div
      className={cn(
        'flex cursor-pointer gap-2 rounded-sm px-2 py-3',
        PaletteUtils.isInsigniaPalette && ['bg-ice dark:bg-eerie-black', 'hover:bg-ghost-white dark:hover:bg-transport-black'],
        PaletteUtils.isVcfcPalette && ['bg-ghost-white dark:bg-light/5', 'hover:bg-gainsborough dark:hover:bg-light/20'],
        props.className,
      )}
      onClick={props.onClick}
    >
      <Text className='flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary' weight='semibold' color='white'>
        {FormatUtils.getRecipientInitials(props.recipient)}
      </Text>
      <ul>
        <Text tag='li' weight='semibold'>
          {FormatUtils.getRecipientName(props.recipient)}
        </Text>
        <Text tag='li' size='xs' color={PaletteUtils.getPaletteParam('secondary', 'gray')}>
          {props.recipient.iban || props.recipient.accountNumber || '-'}
        </Text>
      </ul>
    </div>
  );
};
